import { render, staticRenderFns } from "./DuelChallenge_Actions_Challenged.vue?vue&type=template&id=69211320&"
import script from "./DuelChallenge_Actions_Challenged.vue?vue&type=script&lang=js&"
export * from "./DuelChallenge_Actions_Challenged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports